/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ContractsAliases {
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  AVATAR_0 = 'avatar-0',
  CARD_CONTRACT = 'card-contract',
  CHECKBOX_0 = 'checkbox-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_CONTRACTS = 'deck-contracts',
  FETCH_CONTRACTS = 'fetch-contracts',
  FETCH_LOCATOR = 'fetch-locator',
  FETCH_MESSAGE = 'fetch-message',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_EXPIRATION = 'field-expiration',
  FIELD_PROVIDER = 'field-provider',
  FIELD_VALIDY = 'field-validy',
  FILTER = 'filter',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_0 = 'form-0',
  LAYOUT_0 = 'layout-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_5 = 'text-5',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
}
export { ContractsAliases };
